import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styles from './Navigation.module.less';
import NavigationLinkItem from './NavigationLinkItem/NavigationLinkItem';
import NavigationMenuItem from './NavigationMenuItem/NavigationMenuItem';
import {
  redirectToLogout,
  redirectToPrivilegedLogout
} from '../../../../utils/login';
import { privilegedLogout } from '../../../../service/privileged-auth';
import productSvg from '../../../../assets/images/product.svg';
import portalSvg from '../../../../assets/images/portal.svg';
import history from '../../../../history';
import securitySvg from '../../../../assets/images/security.svg';

const Navigation = ({
  isLogin,
  userName,
  userSvg,
  groupSvg,
  className,
  isShowConsole,
  isShowProductManagement,
  isShowPortal,
  isShowPrivilegedConsole,
  isShowPrivilegeCheckinConsole
}) => {
  const isPrivilegedAccount = useSelector(
    state => state.account.privilegedAccount
  );

  const handlePrivilegedLogout = async () => {
    try {
      await privilegedLogout();
    } finally {
      redirectToPrivilegedLogout();
    }
  };

  const userMenus = [
    {
      text: 'User Profile',
      onMenuItemClick: () => history.push('/user/profile')
    },
    {
      text: 'Logout',
      onMenuItemClick: isPrivilegedAccount
        ? handlePrivilegedLogout
        : redirectToLogout
    }
  ];

  const navigationItems = useMemo(() => {
    const items = [];
    if (isShowConsole) {
      items.push({
        name: 'Console',
        pathname: '/console/iam/users',
        icon: groupSvg
      });
    }
    if (isShowProductManagement) {
      items.push({
        name: 'Product Management',
        pathname: '/product-management',
        icon: productSvg
      });
    }
    if (isShowPortal) {
      items.push({
        name: 'Portal',
        pathname: '/portal',
        icon: portalSvg
      });
    }
    if (isShowPrivilegedConsole) {
      items.push({
        name: 'Privileged Console',
        pathname: '/privileged/console',
        icon: securitySvg
      });
    }
    if (isShowPrivilegeCheckinConsole) {
      items.push({
        name: 'Privilege Check-in',
        pathname: '/privilege-checkin/checkin',
        icon: securitySvg
      });
    }
    return items;
  }, [
    groupSvg,
    isShowConsole,
    isShowPortal,
    isShowProductManagement,
    isShowPrivilegedConsole,
    isShowPrivilegeCheckinConsole
  ]);

  const renderNavArea = () => (
    <>
      {navigationItems.map(({ name, pathname, icon }) => (
        <NavigationLinkItem
          name={name}
          pathname={pathname}
          icon={icon}
          className={className}
          key={name}
        />
      ))}
      <NavigationMenuItem
        text={userName}
        icon={userSvg}
        menus={userMenus}
        className={className}
      />
    </>
  );

  return <div className={styles.navigation}>{isLogin && renderNavArea()}</div>;
};

Navigation.defaultProps = {
  isShowConsole: false,
  isShowProductManagement: false,
  isShowPortal: false,
  isShowPrivilegedConsole: false,
  isShowPrivilegeCheckinConsole: false
};
Navigation.propTypes = {
  isLogin: PropTypes.bool.isRequired,
  userName: PropTypes.string.isRequired,
  userSvg: PropTypes.any.isRequired,
  groupSvg: PropTypes.any.isRequired,
  className: PropTypes.string.isRequired,
  isShowConsole: PropTypes.bool,
  isShowProductManagement: PropTypes.bool,
  isShowPortal: PropTypes.bool,
  isShowPrivilegedConsole: PropTypes.bool,
  isShowPrivilegeCheckinConsole: PropTypes.bool
};

export default Navigation;
